import 'es6-promise/auto'
import 'core-js/fn/object/assign'

import Vue from 'vue'
import App from './App'
// import { activityId } from './config'
import eventEmitter from 'assets/plugins/eventEmitter.js'
import log from 'assets/plugins/log.js'

if (process.env.NODE_ENV === 'production' && process.env.__ENV === 'test') {
  var VConsole = require('vconsole/dist/vconsole.min.js')
  /* eslint-disable no-new */
  new VConsole()
}

// 引入自定义事件
Vue.use(eventEmitter, ['onResume', 'onPause'])

// 打点
Vue.use(log)

Vue.config.productionTip = false

const FastClick = require('fastclick')
FastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})

// window.Log.pageView({
//   targetView: activityId
// })



// WEBPACK FOOTER //
// ./src/main.js